import { call, put, takeLatest, fork } from "redux-saga/effects";

import {
  MASTERCRONSCHEDULE_LIST_OVERDUE,
  MASTERCRONSCHEDULE_LIST,
  MASTERCRONSCHEDULE_REQUESTRUN,
} from "./actionType";

//actions success fail
import {
  masterCronScheduleListOverdueSuccess,
  masterCronScheduleListOverdueFailure,
  masterCronScheduleListSuccess,
  masterCronScheduleListFailure,
  masterCronScheduleRequestRunSuccess,
  masterCronScheduleRequestRunFailure,
} from "./action";

//api
import {
  fetchMasterCronScheduleListOverdue,
  fetchMasterCronScheduleList,
  fetchMasterCronScheduleRequestRun,
} from "../../helpers/fakebackend_helper";

//MASTERCRONSCHEDULE_LIST_OVERDUE
function* handleMasterCronScheduleListOverdue() {
  try {
    const response = yield call(fetchMasterCronScheduleListOverdue);
    yield put(masterCronScheduleListOverdueSuccess(response));
  } catch (error) {
    yield put(masterCronScheduleListOverdueFailure(error));
  }
}

function* watchMasterCronScheduleListOverdue() {
  yield takeLatest(
    MASTERCRONSCHEDULE_LIST_OVERDUE,
    handleMasterCronScheduleListOverdue
  );
}

//MASTERCRONSCHEDULE_LIST
function* handleMasterCronScheduleList() {
  try {
    const response = yield call(fetchMasterCronScheduleList);
    yield put(masterCronScheduleListSuccess(response));
  } catch (error) {
    yield put(masterCronScheduleListFailure(error));
  }
}

function* watchMasterCronScheduleList() {
  yield takeLatest(MASTERCRONSCHEDULE_LIST, handleMasterCronScheduleList);
}

//MASTERCRONSCHEDULE_REQUESTRUN
function* handleMasterCronScheduleRequestRun(action) {
  try {
    const response = yield call(
      fetchMasterCronScheduleRequestRun,
      action.payload
    );
    yield put(masterCronScheduleRequestRunSuccess(response));
  } catch (error) {
    yield put(masterCronScheduleRequestRunFailure(error));
  }
}

function* watchMasterCronScheduleRequestRun() {
  yield takeLatest(
    MASTERCRONSCHEDULE_REQUESTRUN,
    handleMasterCronScheduleRequestRun
  );
}

export default function* cronSchedulesSaga() {
  yield fork(watchMasterCronScheduleListOverdue);
  yield fork(watchMasterCronScheduleList);
  yield fork(watchMasterCronScheduleRequestRun);
}
